export const projectArr = [
    {
      class:'odd',
      link:'https://swiggy-red.vercel.app/',
      ProjectName:'Swiggy Clone (MERN Stack)',
      decs:[
        'Developed a Swiggy clone application using the MERN stack "(MongoDB, Express.js, React.js, Node.js)"} with Redux Toolkit for state management.',
        'FRONTEND: Built a responsive user interface using React.js, implementing state management with Redux Toolkit for efficient data flow and real-time updates.',
        'BACKEND: Designed and developed RESTful APIs using Node.js and Express.js for handling CRUD operations and user authentication using JWT token.',
        'DATABASE: Utilized MongoDB for storing and managing user data, orders, and product information.'
      ]
    },
    {
      class:'even',
      link:'https://clever-kringle-e6600e.netlify.app/',
      ProjectName:'TODO APP',
      decs:[
        'Developed a fully functional to-do application using ReactJS that allows users to manage their tasks efficiently, like creating, reading, and deleting tasks. It also filters the tasks based on whether they are complete or incomplete.',
        'Implemented a clean,user-friendly interface with Bootstrap and ensured responsive design.'
      ]
    },
    {
      class:'odd',
      link:'https://astonishing-tulumba-229c17.netlify.app/',
      ProjectName:'TRAVEL REACT APP',
      decs:[
        'Build a travel website using ReactJS and CSS that has multiple path ways and pages, including HOME, ABOUT US, CONTACT US, LOGIN, and SIGNUP.',
        'It is hosted on Netlify.'
      ]
    },
    {
      class:'even',
      link:'https://667cdecdd40c4c4d74457111--incandescent-semifreddo-a3b638.netlify.app/',
      ProjectName:'FITNESS STAR GYM',
      decs:[
        'Designed and developed a comprehensive gym website to provide information about, service, blogs, and membership plans.',
        'Ensure the website is fully responsive and optimized for various devices.'
      ]
    },
    {
      class:'odd',
      link:'https://moonlit-kitten-5cc6bf.netlify.app/',
      ProjectName:'WEATHER FORECASTING',
      decs:[
        'I have created a static webpage for weather forecasting.',
        'Display the current temperature, humidity, wind speed, and conditions.'
      ]
    },
  ]